// extracted by mini-css-extract-plugin
export default {"icon":"Logo_icon__+al7b","nav-load":"Logo_nav-load__H+Uc2"};